import TabCase from "@ext/markdown/elements/tabs/render/component/TabCase";
import { ReactElement } from "react";

type TabProps = {
	idx: number;
	name?: string;
	icon?: string;
	isPrint?: boolean;
	children?: ReactElement;
};

const Tab = ({ idx, name, icon, isPrint, children }: TabProps): ReactElement => {
	if (isPrint) {
		return (
			<div className="tab">
				<TabCase idx={idx} name={name} icon={icon} />
				<div className="content">{children}</div>
			</div>
		);
	}

	return <div className={`tab c-${idx}`}>{children}</div>;
};

export default Tab;
